import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
} from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { RouterLink } from "@angular/router";
import { AuthService } from "../../../services/auth.service";
import { AsyncPipe } from "@angular/common";
import { UserFacade } from "../../../store/facade/user.facade";

@Component({
    standalone: true,
    selector: "gwo-header",
    imports: [
        MatIcon,
        MatToolbar,
        MatIconButton,
        MatButton,
        MatMenuTrigger,
        MatMenu,
        MatMenuItem,
        RouterLink,
        AsyncPipe,
    ],
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
    @Input() name = "";

    private readonly userFacade = inject(UserFacade);
    readonly authService = inject(AuthService);
    readonly user$ = this.userFacade.user$;

    onSingOutClick(): void {
        this.authService.logout();
    }
}
